<template>
  <div class="project">
    <h1 class="title">My Projects</h1>
    <div v-for="projects in json" class="card">
      <div class="card-content">
        <h2 class="title is- 2">{{projects.name}}</h2>
        <div class="columns">
          <div class="column">
           <figure class="image">
              <img :src="projects.img">
            </figure> 
          </div>
          <div class="column">
            <p>{{projects.content}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import projectJson from '../json/projects.json'

export default {
  name: 'Projects',
  data(){
    return{
      json: projectJson
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
figure{
  height: auto;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
